import { useEffect } from "react";
import { usePrevious } from "react-use";
import { useFormikContext } from "formik";

const getSelectedIndex = (options, valueToFind) => options.map(({ value }) => value).indexOf(valueToFind);

const setFormValueToMatchPreviousIndex = (setFieldValue, name, newValue) => {
  setFieldValue(name, newValue);
};

const createValueIdentifierForOptions = (options) =>
    options.reduce((accumulator, { value }, index) => accumulator + `i=${index},v=${value}`, "");

const useSelectIdentifier = (options) => {
  const optionsIdentifier = createValueIdentifierForOptions(options);
  const previousOptionsIdentifier = usePrevious(optionsIdentifier);

  return [optionsIdentifier, previousOptionsIdentifier];
}

export const useSelectedIndexMaintainer = (options, name) => {
  const { setFieldValue, values } = useFormikContext();
  const value = values[name];
  const previousSelectedIndex = usePrevious(getSelectedIndex(options, value));
  const [optionsIdentifier, previousOptionsIdentifier] = useSelectIdentifier(options);

  useEffect(() => {
    const potentialNewValue = (options[previousSelectedIndex] || {}).value;
    const identifiersDontMatch = optionsIdentifier !== previousOptionsIdentifier;
    const hasNewValueToSelect = identifiersDontMatch && previousSelectedIndex !== -1 && !!potentialNewValue;

    if (hasNewValueToSelect) {
      setFormValueToMatchPreviousIndex(setFieldValue, name, potentialNewValue);
    }
  }, [name, options, optionsIdentifier, previousOptionsIdentifier, previousSelectedIndex, setFieldValue, value]);
};